import script from "./jijia-application-example.vue?vue&type=script&lang=ts&setup=true"
export * from "./jijia-application-example.vue?vue&type=script&lang=ts&setup=true"

import "./jijia-application-example.vue?vue&type=style&index=0&id=3a3bf784&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a3bf784"]])

export default __exports__